import { FETCH_INVOICES, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchInvoicesSummaryReducer = (summary, payload) => {

    summary = [];
    for(let s of payload){
        summary.push(s);
    }
    return summary;
}

const invoicesSummaryReducer = (state=[], action) => {
    let summary = state;
    if (action && action.summary && !action.payload.errors && action.type === FETCH_INVOICES){
        summary = fetchInvoicesSummaryReducer(summary, action.summary);
    } else if (action.type === LOG_OUT_USER){
        summary = []
    }

    return summary;
}

export default invoicesSummaryReducer;